export default __webpack_public_path__ + "static/media/Karnataka-Central.f9e861e1.png";